import { render } from "./HomePage.vue?vue&type=template&id=f8eff4d8&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f8eff4d8"

export default script